export default "__VITE_ASSET__Bi9OPa44__"